import Main from './Main.vue'
import Comitentes from './components/Comitentes.vue'
import Comitente from './components/Comitente.vue'
import VisualizarComitente from './components/VisualizarComitente.vue'

export default [{
  path: 'comitentes',
  name: 'comitentes',
  component: Main,
  children: [
    {path: '/', component: Comitentes, name: 'comitentes'},
    {path: 'registrar', component: Comitente, name: 'comitente.novo'},
    {path: ':id', component: VisualizarComitente, name: 'comitente.visualizar'},
    {path: ':id/edit', component: Comitente, name: 'comitente.editar'}
  ]
}
]



// WEBPACK FOOTER //
// ./src/app/website/comitentes/routes.js